import React, { useState } from "react";
import axios from "axios";
import { apiKey } from "../config/config";
import { toast } from "react-toastify";

export default function OpenShift({ lang, dirFormat, onShiftOpened }) {
  const [openingBalance, setOpeningBalance] = useState("0.00");
  const [loading, setLoading] = useState(false);

  const token = JSON.parse(sessionStorage.getItem("aman-admin") || "null")
    ?.admin
    ? JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).token
    : null;
  const branchId = JSON.parse(sessionStorage.getItem("aman-admin") || "null")
    ?.admin
    ? JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).branch_id
    : null;

  const handleOpenShift = (e) => {
    e.preventDefault();
    if (!branchId || !token) {
      toast.error(lang?.Lang === "ar" ? "حدث خطأ في قراءة بيانات الجلسة" : "Session data error");
      return;
    }

    setLoading(true);
    axios
      .post(
        `${apiKey}/open-shift`,
        {
          openingBalance: parseFloat(openingBalance) || 0,
          branchId: branchId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        toast.success(lang?.Lang === "ar" ? "تم افتتاح الفترة بنجاح" : "Shift Opened Successfully");
        setTimeout(() => {
          onShiftOpened();
        }, 1000);
      })
      .catch((err) => {
        console.error(err);
        toast.error(
          lang?.Lang === "ar"
            ? "فشل في افتتاح الفترة. يرجى المحاولة مرة أخرى."
            : "Failed to open shift. Please try again."
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const isRtl = dirFormat === "rtl" || lang?.Lang === "ar";

  return (
    <div
      className="container d-flex justify-content-center align-items-center"
      style={{ minHeight: "80vh" }}
      dir={isRtl ? "rtl" : "ltr"}
    >
      <div
        className="card shadow p-5"
        style={{
          width: "100%",
          maxWidth: "500px",
          borderRadius: "15px",
          backgroundColor: "var(--card-bg, #ffffff)",
          border: "1px solid rgba(0, 0, 0, 0.05)",
        }}
      >
        <div className="text-center mb-4">
          <div className="mb-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="64"
              height="64"
              fill="currentColor"
              className="text-primary"
              viewBox="0 0 16 16"
            >
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
              <path d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5z" />
            </svg>
          </div>
          <h2 className="text-primary font-weight-bold" style={{ fontSize: "1.75rem" }}>
            {lang["Open New Shift"] || "Open New Shift"}
          </h2>
          <p className="text-muted mt-2" style={{ fontSize: "0.95rem", lineHeight: "1.5" }}>
            {lang["Please enter the opening balance to start the daily shift for this office."] || "Please enter the opening balance to start the daily shift for this office."}
          </p>
        </div>

        <form onSubmit={handleOpenShift}>
          <div className="form-group mb-4">
            <label className="font-weight-bold mb-2 text-secondary" style={{ fontSize: "0.9rem" }}>
              {lang?.Opening_Balance || "Opening Balance"}
            </label>
            <div className="input-group">
              <input
                type="number"
                step="0.01"
                min="0"
                className="form-control form-control-lg text-center"
                style={{
                  fontSize: "1.5rem",
                  letterSpacing: "1px",
                  borderRadius: "8px",
                  border: "2px solid #e2e8f0",
                }}
                value={openingBalance}
                onChange={(e) => setOpeningBalance(e.target.value)}
                placeholder="0.00"
                disabled={loading}
                autoFocus
              />
            </div>
          </div>

          <button
            type="submit"
            className="btn btn-primary btn-lg w-100 font-weight-bold shadow-sm py-3"
            style={{ borderRadius: "8px", fontSize: "1.1rem" }}
            disabled={loading}
          >
            {loading ? (
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            ) : null}
            {lang["Open Shift"] || "Open Shift"}
          </button>
        </form>
      </div>
    </div>
  );
}
